export const columna = [

	

	{
	"nombre": "Noticias.",
	"imagen": "noticias/empresasintegras.jpg",
	"funcion": "¿Qué significa ser una Empresa Íntegra? “Empresas Íntegras Hidalgo” es una iniciativa que vincula al gobierno, las empresas y la ciudadanía para impulsar prácticas corporativas éticas, fortalecer la transparencia y prevenir riesgos de corrupción. Construir relaciones basadas en la honestidad, la responsabilidad y la confianza contribuye a un entorno empresarial más sólido y transparente.",
	"url": "https://www.facebook.com/share/p/19SFNy6a9N"
    },
	{
	"nombre": "Noticias.",
	"imagen": "noticias/actividades-semana.jpg",
	"funcion": "En 60 segundos te mostramos las actividades de la semana en la #Contraloría #ElHidalgoQueQueremos.",
	"url": "https://www.facebook.com/share/v/1CEbSvxWcC"
    } ,

	{
	"nombre": "Noticias.",
	"imagen": "noticias/podcast-empresas-integras.jpg",
	"funcion": "En este episodio del Podcast del Pueblo hablamos del Catálogo de Empresas Íntegras Hidalgo: qué es, qué requisitos deben cumplir las empresas para formar parte y cuáles son los beneficios de fortalecer una cultura de integridad. Conoce cómo la transparencia, la ética y la prevención de la corrupción también se construyen desde el sector empresarial. Escucha el episodio completo. #PrimeroElPueblo",
	"url": "https://www.facebook.com/share/v/1F15snWomy"
},

	{
		"nombre": "Noticias.",
		"imagen": 'noticias/buzón.jpg',
		"funcion": "Buzón Digital",
		"url": "https://buzondigitalcontraloria.hidalgo.gob.mx/"
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]